import React from "react";
import { useLanguageContent } from "../../Components/LangueContentLoader";
import logo from "../../Images/bocaux/logo.png";
import mockup from "../../Images/bocaux/mockup.png";
import flyer from "../../Images/CUEL/flyerLBDU.png";
import dpcouv from "../../Images/bocaux/dpcouverture.png";
import wireframes from "../../Images/bocaux/wireframes.png";
import stratCom from "../../Images/bocaux/stratCom.png";
import screenSite from "../../Images/bocaux/screenSite.png";
import planHebdo from "../../Images/bocaux/comHebdo.png";
import planContenu from "../../Images/bocaux/planContenu.png";

export default function LesBocauxProject() {
  const content = useLanguageContent();
  return (
    <main>
      <section>
        <h1 className="banner-text single-project-title">
          {content.Projet}&nbsp;
          <p className="salmon">{content.Bocaux.title}</p>
        </h1>
        <h2>{content.Introduction}</h2>
        <p>{content.Bocaux.intro}</p>
      </section>

      <section>
        <img className="img-projects" src={logo} alt="Logo of a company" />
      </section>

      <section>
        <h2>{content.Bocaux.DP}</h2>
        <p>{content.Bocaux.DPdesc}</p>
      </section>

      <section>
        <img
          className="img-projects"
          src={dpcouv}
          alt="couverture d'un dossier professionnel"
        />
      </section>
      <section>
        <img
          className="img-projects"
          src={flyer}
          alt="flyer for a restaurant"
        />
        <p className="italique">{content.CUEL.desc1}</p>
      </section>

      <section>
        <h2>{content.CUEL.work}</h2>
        <p>
          {content.BocauxMarketing.map((objectif, index) => (
            <li key={index}>- {objectif}</li>
          ))}
        </p>
      </section>

      <section>
        <h2>{content.Bocaux.design}</h2>
        <p>{content.Bocaux.design2}</p>
      </section>

      <section>
        <img
          className="img-projects"
          src={mockup}
          alt="mockups d'un site internet"
        />
      </section>

      <section>
        <img
          className="img-projects"
          src={wireframes}
          alt="wireframes d'un site internet"
        />
      </section>
      <section>
        <img
          className="img-projects"
          src={screenSite}
          alt="Capture d'un site internet"
        />
        <p className="italique">{content.Bocaux.site}</p>
      </section>

      <section>
        <h2>{content.Bocaux.comTitle}</h2>
        <p>{content.Bocaux.comPoint}</p>
      </section>

      <section>
        <img
          className="img-projects"
          src={stratCom}
          alt="wireframes d'un site internet"
        />
        <p className="italique">{content.Bocaux.stratCom2}</p>
      </section>

      <section>
        <img
          className="img-projects"
          src={planHebdo}
          alt="plan hebdomadaire de tableaux Excel"
        />
      </section>
      <section>
        <img
          className="img-projects"
          src={planContenu}
          alt="plan contenue de tableaux Excel"
        />
      </section>
    </main>
  );
}
